export default __webpack_public_path__ + "static/media/streaks 7.b2dfb416.svg";